import React from 'react';
import { IndexLink } from 'react-router';
import _ from "i18n";
import { VERTICAL } from "constants";

export const SubMenuLink = ({ pathname, title, icon, subMenuDirection, currentClient }) => {
  return (
    <React.Fragment>
      <li><IndexLink to="/admin/statistics" activeClassName="active" className="menu__link"><span className="title">{_('GENERAL')}</span></IndexLink></li>
      <li><IndexLink to="/admin/eventstats" activeClassName="active" className="menu__link"><span className="title">Event</span></IndexLink></li>
      {currentClient.id === 1256 && <li><IndexLink to="/admin/contributionstats" activeClassName="active" className="menu__link"><span className="title">COTISATIONS</span></IndexLink></li>}
      {currentClient.id === 4442 && <li><IndexLink to="/admin/paperstats" activeClassName="active" className="menu__link"><span className="title">PAPER</span></IndexLink></li>}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./app/components/menu/SubMenuLink.js